import {
  Datepicker,
  Icon,
  IndexPath,
  Input,
  Layout,
  Select,
  SelectItem,
} from '@ui-kitten/components';
import React, {useCallback, useEffect, useState} from 'react';
import {StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {px} from '../../utils';
import {TitleRow} from '../components';

const CalendarIcon = (props) => <Icon {...props} name="calendar" />;
const genderList = ['Male', 'Female'];

const StudentForm = ({data, setData, index}) => {
  const {studentName, gender: genderInit, gradeId: gradeIdInit, dob} = data;
  const grades = useSelector((state) => state.general.grades);
  const genderInitIndex = genderList.findIndex((value) => value === genderInit);
  const [genderIndex, setGenderIndex] = useState(
    new IndexPath(genderInitIndex > 0 ? genderInitIndex : 0),
  );
  const gradeInitIndex = grades.findIndex(
    (gradeRow) => gradeRow.id === gradeIdInit,
  );
  const [gradeIndex, setGradeIndex] = useState(
    new IndexPath(gradeInitIndex > 0 ? gradeInitIndex : 0),
  );

  const gender = genderList.find((_, rowIndex) => rowIndex === genderIndex.row);

  const gradeObj = grades.find((_, rowIndex) => rowIndex === gradeIndex.row);

  useEffect(() => {
    onChange('gender', gender);
  }, [gender, onChange]);

  useEffect(() => {
    onChange('gradeId', gradeObj.id);
  }, [gradeObj, onChange]);

  const onChange = useCallback(
    (fieldName, text) => {
      setData({...data, [fieldName]: text});
    },
    [data, setData],
  );

  return (
    <Layout style={styles.container}>
      <TitleRow
        type="secondary"
        title={'Student ' + index}
        containerStyle={styles.title}
      />
      <Input
        value={studentName}
        label="Student name"
        onChangeText={(text) => onChange('studentName', text)}
        style={styles.marginTop}
      />

      <Select
        label="Gender"
        style={styles.marginTop}
        value={gender}
        selectedIndex={genderIndex}
        onSelect={setGenderIndex}>
        {genderList.map((item, itemIndex) => (
          <SelectItem title={item} key={itemIndex} />
        ))}
      </Select>
      <Select
        label="Grade"
        style={styles.marginTop}
        value={gradeObj.type}
        selectedIndex={gradeIndex}
        onSelect={setGradeIndex}>
        {grades.map(({type}, itemIndex) => (
          <SelectItem title={type} key={itemIndex} />
        ))}
      </Select>
      <Datepicker
        label="Date of birth"
        style={styles.marginTop}
        placeholder="Choose Date"
        date={dob}
        min={new Date(new Date().setFullYear(new Date().getFullYear() - 20))}
        max={new Date()}
        onSelect={(nextDate) => onChange('dob', nextDate)}
        accessoryRight={CalendarIcon}
      />
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: px(40),
  },
  title: {
    paddingHorizontal: 0,
  },
  marginTop: {
    marginTop: px(17),
  },
});

export default StudentForm;
